'use strict';
angular.module('mandaeApp')
    .controller('HistoricoPedidoEmpacotamentoCtrl', function ($scope) {
        // classe para animação da view
        $scope.pageClass = 'page-empacotamento';
    });